import {MULTI_TIME_BINGO_ROOMS} from "Setup/config";
import extendedDayjs from "Helpers/dayjs";
import {sendLogglyEvent} from "Helpers/loggly";

const temporarySetBingoRoomMultiOpeningTime = (room) => {
    try {
        let updatedRoom = Object.assign({}, room);

        if (!MULTI_TIME_BINGO_ROOMS) return room;
        if (!Object.keys(MULTI_TIME_BINGO_ROOMS).includes(`${updatedRoom.roomId}`)) return room;

        const nowTime = extendedDayjs();
        const times = MULTI_TIME_BINGO_ROOMS[updatedRoom.roomId];

        const isOpen = times.find(t => {
            const [openHour, closeHour] = t;
            let dayJsParsedOpenTime = extendedDayjs().hour(openHour / 100).minute(0).second(0);
            let dayJsParsedCloseTime = extendedDayjs().hour(closeHour / 100).minute(0).second(0);

            if (openHour > closeHour) dayJsParsedCloseTime = dayJsParsedCloseTime.add(1, 'day');

            return nowTime.isAfter(dayJsParsedOpenTime) && nowTime.isBefore(dayJsParsedCloseTime);
        });

        updatedRoom.open = true;
        updatedRoom.secondsTilOpen = false;

        if (!isOpen) {
            updatedRoom.open = false;
            const TimeAOpen = extendedDayjs().hour(times[0][0] / 100).minute(0).second(0);
            const TimeBOpen = extendedDayjs().hour(times[1][0] / 100).minute(0).second(0);
            const TimeAOpenNextDay = TimeAOpen.add(1, 'day');

            // The room is not open, we need to correct the opening time
            if (nowTime.isBefore(TimeAOpen)) {
                updatedRoom.secondsTilOpen = Math.floor(TimeAOpen.diff(nowTime) / 1000);
            } else if (nowTime.isBefore(TimeBOpen)) {
                updatedRoom.secondsTilOpen = Math.floor(TimeBOpen.diff(nowTime) / 1000);
            } else {
                updatedRoom.secondsTilOpen = Math.floor(TimeAOpenNextDay.diff(nowTime) / 1000);
            }
        }

        return updatedRoom;
    } catch (e) {
        console.log(e);
        sendLogglyEvent('Bingo Rooms', 'Multi Opening Time', e);
    }

    return room;
}

export default temporarySetBingoRoomMultiOpeningTime;